module.exports = __webpack_public_path__ + "img/logo-circular.d1345bb8.svg";